import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home, LedProduct, Business, ProjectorProduct, Portfolio, PortfolioDetailPage, Support, Inquiry, NoticeDetailPage, FaqPage, AdminLogin, AdminDashboard } from './routes';
import ScrollToTop from './components/scrollToTop/ScrollToTop';
import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminLayout from './components/admin/layout/AdminLayout';
import AdminPortfolio from './routes/AdminPortfolio';
import AdminPortfolioForm from './routes/AdminPortfolioForm';
import AdminInquiry from './routes/AdminInquiry';
import AdminNotice from './routes/AdminNotice';
import AdminNoticeForm from './routes/AdminNoticeForm';
import AdminFaq from './routes/AdminFaq';
import AdminFaqForm from './routes/AdminFaqForm';
import AdminAccount from './routes/AdminAccount';
import RentalService from './routes/RentalService';
import Privacy from './routes/Privacy';

const Navigation = () => {
    return (
        <BrowserRouter>
            <ScrollToTop />

            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='business' element={<Business />} />
                <Route path='portfolio' element={<Portfolio />} />
                <Route path='rentalService' element={<RentalService />} />
                <Route path='products/led' element={<LedProduct />} />
                <Route path='products/projector' element={<ProjectorProduct />} />
                <Route path='portfolio' element={<Portfolio />} />
                <Route path='portfolio/:id' element={<PortfolioDetailPage />} />
                <Route path='support' element={<Support />} />
                <Route path='support/notice/:id' element={<NoticeDetailPage />} />
                <Route path='support/faq' element={<FaqPage />} />
                <Route path='inquiry' element={<Inquiry />} />
                <Route path='admin' element={<AdminLogin />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route
                    element={
                        <ProtectedRoute>
                            <AdminLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    <Route path="/admin/inquiries" element={<AdminInquiry />} />
                    <Route path="/admin/portfolios" element={<AdminPortfolio />} />
                    <Route path="/admin/portfolios/new" element={<AdminPortfolioForm />} />
                    <Route path="/admin/portfolios/:id/edit" element={<AdminPortfolioForm />} />
                    <Route path="/admin/notices" element={<AdminNotice />} />
                    <Route path="/admin/notices/new" element={<AdminNoticeForm />} />
                    <Route path="/admin/notices/:id/edit" element={<AdminNoticeForm />} />
                    <Route path="/admin/faqs" element={<AdminFaq />} />
                    <Route path="/admin/faqs/new" element={<AdminFaqForm />} />
                    <Route path="/admin/faqs/:id/edit" element={<AdminFaqForm />} />
                    <Route path="/admin/account" element={<AdminAccount />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default Navigation;
